import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from '/node_modules/element-ui/lib/locale/lang/en'

Vue.use(Element,{locale})
